import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    // WauWow: MP4 vor HLS (m3u8) einsortieren. Neuere Chromium-Browser melden HLS als abspielbar, laden die Playlist aber teils nicht
    // und das Hintergrundvideo bleibt stehen. Die MP4-Quelle laeuft ueberall.
    const mp4 = videoSources.filter((s) => s.getAttribute('type') === 'video/mp4');
    for (const s of mp4.reverse()) videoElement.prepend(s);

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
